import { canAccessAdminRoutes } from '@/utils/routeGuards';
import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/payments',
    name: 'Payments',
    component: () => import('@/views/PaymentsPage.vue'),
    redirect: { name: 'TeamPayments' },
    meta: {
      layout: 'LayoutAuthenticated',
      requiresAuth: true,
      title: 'pagePayments.metaTitle',
      layoutOptions: {
        noAppBarBorder: true,
      },
    },
    beforeEnter: [canAccessAdminRoutes],
    children: [
      {
        path: 'list',
        name: 'TeamPayments',
        component: () => import('@/views/TeamPayments.vue'),
      },
      {
        path: 'cashflow',
        name: 'TeamCashFlow',
        component: () => import('@/views/TeamCashFlow.vue'),
      },
    ],
  },
];
export default routes;
